import {
  buffer,
  Feature,
  featureCollection,
  featureReduce,
  MultiPolygon,
  Polygon,
  Properties,
  union,
} from "@turf/turf";
// @ts-expect-error - turf/index.d.ts doesn't list this function
import { booleanIntersects } from "@turf/turf";
import { compact } from "lodash";

import {
  BlockLayer,
  ExclusionLayer,
  isExclusionLayer,
  PerimeterLayer,
} from "./BlockLayerModel";

export const DEFAULT_EXCLUSION_RADIUS = 1;

export function getExclusionPoly(
  layer: ExclusionLayer
): Feature<Polygon, Properties> | undefined {
  return buffer(
    layer.geojson,
    layer.geojson.properties.bufferRadius ?? DEFAULT_EXCLUSION_RADIUS,
    { units: "meters" }
  );
}

export function getExclusionFromLayers(layers: ExclusionLayer[]) {
  if (!layers.length) {
    return null;
  }

  const exclusions = compact(layers.map(getExclusionPoly));
  const exclusion = featureReduce(
    featureCollection(exclusions.slice(1)),
    (acc, feature) => union(acc, feature) ?? acc,
    exclusions[0] as Feature<Polygon | MultiPolygon>
  );

  return exclusion;
}

export function exclusionZonesByBlockId(
  blockPerimeterLayers: BlockLayer[],
  exclusionLayers: BlockLayer[]
) {
  const exclusionAreas = (exclusionLayers as unknown as ExclusionLayer[]).map(
    getExclusionPoly
  );

  if (!exclusionAreas.length) {
    return {};
  }

  return (blockPerimeterLayers as PerimeterLayer[]).reduce<
    Record<string, ExclusionLayer[]>
  >((acc, perimeter) => {
    if (!perimeter.block_id) {
      return acc;
    }

    if (!acc[perimeter.block_id]) {
      acc[perimeter.block_id] = [];
    }

    acc[perimeter.block_id].push(
      ...exclusionLayers.filter(isExclusionLayer).filter((layer, i) => {
        return (
          exclusionAreas[i] &&
          booleanIntersects(exclusionAreas[i], perimeter.geojson)
        );
      })
    );

    return acc;
  }, {});
}
